import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { NavigationMenuProps } from "@radix-ui/react-navigation-menu";
import React from "react";
import { Link } from "react-router-dom";

export type NavLink = {
  name: string;
  to: string;
};

type NavMenuProps = NavigationMenuProps & {
  links: NavLink[];
};

export const NavMenu = ({ links, orientation, ...props }: NavMenuProps) => {
  return <NavigationMenu viewport={false} orientation={orientation} {...props}>
    <NavigationMenuList className="gap-6 data-[orientation=vertical]:w-full data-[orientation=vertical]:gap-0 space-x-0 data-[orientation=vertical]:flex-col flex-row data-[orientation=vertical]:items-start data-[orientation=vertical]:divide-y-1">
      {
        links.map((link) => (
          <NavigationMenuItem className={orientation == "vertical" ? "w-full" : undefined} key={link.to}>
            <NavigationMenuLink asChild>
              <Link className={"dark:text-white w-full" + (orientation == "vertical" ? " p-4 rounded-none!" : "" )} to={link.to}>
                {link.name}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        ))
      }
    </NavigationMenuList>
  </NavigationMenu>
};
